import { IconButton, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { mdiClockOutline, mdiHistory, mdiPulse } from '@mdi/js';
import Icon from '@mdi/react';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LATEST_PROJECTS_SOURCE_MODES } from 'store/projects/selectors/projectsSelectors';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  // Bare icon buttons — no background, only the icon; the inactive source is
  // dimmed.
  button: {
    padding: theme.spacing(0.5),
    color: theme.palette.text.primary,
    opacity: 0.4,
  },
  buttonActive: {
    opacity: 1,
  },
}));

// Two small icon buttons toggling the "latest projects" source: any activity
// vs only projects with own records. Presentational — the callers wire it to
// their own slice key (Projects list vs the navbar timer drawer) and control
// the surrounding spacing via className.
export default function ProjectsSourceModeToggle({
  sourceMode,
  onChange,
  className,
}) {
  const classes = useStyles();
  const { t } = useTranslation();

  const options = [
    {
      mode: LATEST_PROJECTS_SOURCE_MODES.ANY_ACTIVITY,
      label: t('project.source_any_activity', 'Kaikki aktiivisuus'),
      iconPath: mdiPulse,
    },
    {
      mode: LATEST_PROJECTS_SOURCE_MODES.RECORDS,
      label: t('project.source_records', 'Vain kirjaukset'),
      iconPath: mdiClockOutline,
    },
  ];

  return (
    <div
      className={clsx(classes.root, className)}
      role="group"
      aria-label={t('project.source_mode', 'Aktiivisuuden lähde')}
    >
      {options.map(({ mode, label, iconPath }) => {
        const isActive = sourceMode === mode;

        return (
          <Tooltip key={mode} title={label}>
            <IconButton
              className={clsx(classes.button, isActive && classes.buttonActive)}
              aria-pressed={isActive}
              aria-label={label}
              onClick={() => {
                if (!isActive) {
                  onChange(mode);
                }
              }}
            >
              <Icon path={iconPath} size={0.6} />
            </IconButton>
          </Tooltip>
        );
      })}
    </div>
  );
}
